import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  title: string;
}

const ImageModal = ({ isOpen, onClose, imageUrl, title }: ImageModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[100vw] max-h-[100vh] w-full h-full sm:max-w-[95vw] sm:max-h-[95vh] p-0 bg-black/95 border-none overflow-hidden">
        <VisuallyHidden>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>View profile photo</DialogDescription>
        </VisuallyHidden>
        <div className="relative w-full h-full flex items-center justify-center p-2 sm:p-4">
          <Button
            variant="ghost"
            size="sm"
            className="absolute top-2 right-2 sm:top-4 sm:right-4 z-50 h-10 w-10 rounded-full bg-white/30 backdrop-blur-sm hover:bg-white/40 text-white shadow-lg"
            onClick={onClose}
            aria-label="Close"
          >
            <X className="h-5 w-5" />
          </Button>
          <img
            src={imageUrl}
            alt={title}
            className="max-w-full max-h-[calc(100vh-16px)] sm:max-h-[calc(95vh-32px)] w-auto h-auto object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImageModal;